import { Box, Grid, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import PropTypes from 'prop-types';

FormToggle.propTypes = {
  value: PropTypes.object,
  setValue: PropTypes.func,
  name: PropTypes.string,
  options: PropTypes.array,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.string,
  flex: PropTypes.number,
};

export default function FormToggle({
  value,
  setValue,
  name,
  options,
  title,
  disabled,
  color = "info",
  size = 'small',
  flex,
}) {

  return (
    <>
      <Grid item xs={flex}>
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
            {title}
          </Typography>
          <ToggleButtonGroup
            color={color}
            value={value[name]}
            exclusive
            disabled={disabled}
            size={size}
            onChange={(e) => setValue({ ...value, [name]: e.target.value })}
            aria-label="text alignment"
          >
            {options.map((option, index) => (
              <ToggleButton key={index} value={option.value ?? option ?? index}>
                {option.label ?? option}
              </ToggleButton>
            ))}

          </ToggleButtonGroup>
        </Box>
      </Grid >
    </>
  );
}
